import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  PrimaryButton,
  Reject,
  Accept,
  AcceptUpload,
  PrimaryLoadingButton,
  CreateButtonLoading,
} from "../../css components/Button";
import pages from "../../../constants/pages";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import LockMyCampaignDialog from "./campaign form components/LockMyCampaignDialog";
import { checkChannelFields } from "./campaign form components/FormDisplay";

export default function CampaignButtons({
  editState,
  liveUsers,
  formikProps,
  component,
  brandIdentity,
  setTakeUpOffer,
  setDialogUploadCSV,
  setIsSubmitted,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dialog, setDialog] = useState({ state: false });

  const [lockCampaignLoading, setLockCampaignLoading] = useState(false);

  const { activeBrand, userID } = useSelector((state) => state.memberDetails);

  return (
    <Fragment>
      {/* {!!formikProps.values.campaignID &&
        formikProps.values.status !== "CREATED" &&
        formikProps.values.status !== "DRAFT" && (
          <CancelButton
            variant="outlined"
            onClick={() => {
              if (ID && editState) {
                setEditState(!editState);
              } else {
                navigate(-1);
              }
            }}
          >
            Back
          </CancelButton>
        )} */}

      {component === "" && formikProps.values?.status === "DRAFT" && (
        <PrimaryButton
          variant="contained"
          onClick={() =>
            setDialog({
              state: true,
              heading: "Publish Campaign",
              func: publishCampaign,
            })
          }
        >
          {" "}
          Publish Campaign
        </PrimaryButton>
      )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.lock_campaign &&
        formikProps.values?.status === "CREATED" && (
          <CreateButtonLoading
            style={{ marginLeft: "5px" }}
            loading={lockCampaignLoading}
            onClick={() => {
              setDialog({
                state: true,
                heading: " lock campaign?",
                button: "Lock My Campaign",
                func: handleLockCampaign,
              });
            }}
            variant="contained"
          >
            Lock my Campaign
          </CreateButtonLoading>
        )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.sent_for_approval &&
        formikProps.values?.status === "CREATED" &&
        formikProps.values?.campaignStatus !== "Expired" &&
        formikProps.values.adminApprovalStatus === "NOT_SENT" && (
          <PrimaryLoadingButton
            variant="contained"
            style={{ marginLeft: "5px" }}
            loading={lockCampaignLoading}
            onClick={() => {
              setDialog({
                state: true,
                heading: " send request for campaign approval",
                button: "Send for approval",
                func: sendForApproval,
              });
            }}
          >
            Send for Approval
          </PrimaryLoadingButton>
        )}

      {formikProps.values?.campaignID &&
        formikProps.values?.status === "ACTIVE" &&
        formikProps.values?.requestStatus === "ACCEPTED" &&
        formikProps.values.permissionSettings.display_stats && (
          <PrimaryButton
            onClick={() =>
              navigate(
                pages.analytics.route +
                  formikProps.values.campaignID +
                  "?campaignName=" +
                  formikProps.values?.campaign_name?.value
              )
            }
            variant="contained"
          >
            Analytics
          </PrimaryButton>
        )}

      {component === "superadmin" && (
        <Accept
          size="large"
          variant="contained"
          style={{ marginRight: "15px" }}
        >
          Approve Campaign
        </Accept>
      )}

      {brandIdentity &&
        component !== "accepted" &&
        formikProps.values.status !== "ACTIVE" &&
        formikProps.values.campaignStatus !== "REJECTED" &&
        formikProps.values.campaignStatus !== "ACCEPTED" &&
        formikProps.values.campaignStatus !== "PARTIAL_ACCEPTED" &&
        formikProps.values.campaignStatus !== "PARTIAL_REJECTED" &&
        formikProps.values.campaignStatus !== "MISSED" && (
          <Fragment>
            <Reject
              size="large"
              variant="contained"
              style={{ marginRight: "15px" }}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "REJECTED",
                  state: true,
                }))
              }
            >
              Reject
            </Reject>

            <Accept
              size="large"
              variant="contained"
              disabled={
                parseInt(liveUsers?.liveUser) <= 0 || !liveUsers.liveUser
              }
              style={{ marginRight: "15px" }}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "ACCEPTED",
                  state: true,
                }))
              }
            >
              Accept
            </Accept>
          </Fragment>
        )}

      {component === "request" &&
        formikProps.values.csvUpload &&
        (formikProps.values.campaignStatus === "REQUESTED" ||
          formikProps.values.campaignStatus === "REJECTED") && (
          <AcceptUpload
            variant="contained"
            onClick={() => setDialogUploadCSV(true)}
          >
            UPLOAD ACCEPT
          </AcceptUpload>
        )}

      <LockMyCampaignDialog
        dialog={dialog}
        setDialog={setDialog}
        handleLockCampaign={handleLockCampaign}
        lockCampaignLoading={lockCampaignLoading}
      />
    </Fragment>
  );

  function publishCampaign() {
    setLockCampaignLoading(true);
    axios({
      url: "/publish/campaign/" + formikProps.values.campaignID,
      // method: "POST",
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          publishedCampaign: true,
          campaignStatus: "CREATED",
          status: "CREATED",
        }));
        dispatch(
          alert({
            type: "success",
            message: res.message.displayMessage,
          })
        );
      }
      setLockCampaignLoading(false);

      setDialog({ state: false });
    });
  }

  function sendForApproval() {
    setLockCampaignLoading(true);
    axios({
      url: "/send/campaign/admin/approval",
      method: "POST",
      data: {
        campaign_id: formikProps.values.campaignID,
        brand_id: activeBrand.ID,
        user_id: userID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          message: response.data.approval_msg,
          adminApprovalStatus: response.data.approval_status,
          displayStatus: response.data?.display_status,
          campaignStatus: "APPROVAL_REQUESTED",
          status: "APPROVAL_REQUESTED",
        }));
        setIsSubmitted(checkChannelFields(formikProps.values));
        dispatch(
          alert({
            type: "success",
            message: response.data.approval_msg,
          })
        );
        setLockCampaignLoading(false);
        setDialog({ state: false });
      }
    });
  }

  function handleLockCampaign() {
    setLockCampaignLoading(true);
    axios({
      url: "/user/lockCampaign",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: formikProps.values.campaignID,
        sender_brandId: formikProps.values.brandID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          status: response?.data?.status,
          campaignStatus: response.data?.status,
        }));

        setLockCampaignLoading(false);

        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      }
      setDialog({ state: false });
    });
  }
}
